// The WIDGET button shape, not the theme's: a widget stores its lengths as `8` or `'8px'`, while
// the theme has stored `{ value, unit }` since v0. These defaults seed widget buttons.
import type { ThemeButtonDataLegacy, ThemeButtonHoverLegacy } from '@sites/entity-core';
import type { ButtonAdditionalEffectsSettings } from '@components/sp-button-additional-effects-settings/type/button-additional-effects-settings.type';
import type { ButtonIcon } from '@components/sp-button-icon/type/button-icon.type';
import {
    EButtonAdditionalEffectsCondition,
    EButtonAdditionalHoverEffectsTypes,
    EButtonAdditionalStaticEffectsTypes,
    EButtonHoverType,
    EHorizontalPosition,
} from '@common/enums';
import { buttonIconTemplates } from '@common/icons/button-icons';

export const DEFAULT_BUTTON_BASE: ThemeButtonDataLegacy = {
    color: ['rgb(255,255,255)'],
    background: ['rgb(0,0,0)'],
    borderColor: ['rgb(0,0,0)'],
    borderWidth: 2,
    borderRadius: 8,
    borderStyle: 'solid',
};

export const DEFAULT_BUTTON_HOVER_STATES: ThemeButtonHoverLegacy = {
    hoverType: EButtonHoverType.opacity,
    opacity: 80,
    shadow: 'none',
    color: ['rgb(255,255,255)'],
    background: ['rgb(22,117,242)'],
    borderColor: ['rgba(0,0,0,0)'],
};

export const DEFAULT_BUTTON_ADDITIONAL_EFFECTS: ButtonAdditionalEffectsSettings = {
    isActive: false,
    effectCondition: EButtonAdditionalEffectsCondition.hover,
    hoverEffects: EButtonAdditionalHoverEffectsTypes.bounce,
    staticEffects: EButtonAdditionalStaticEffectsTypes.shine,
};

export const DEFAULT_BUTTON_ICON: ButtonIcon = {
    isActive: false,
    icon: buttonIconTemplates.telegram,
    position: EHorizontalPosition.L,
};
